@use '../../scss/utility/functions' as utility;
@use './button-group-style-api.scss';

:host {
  --focus-color: var(--btn-group-color-focus);

  display: inline-flex;
  align-items: center;
}

:host([direction='horizontal']) {
  flex-direction: row;
}

:host([direction='vertical']) {
  flex-direction: column;
  align-items: stretch;
}

::slotted(.wb-popover) {
  margin-inline-start: -0.0625rem;
}
